module.exports = __webpack_public_path__ + "static/img/mobile-web-main-01@t.7bf4611.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/mobile-web-main-01@t.png
// module id = P4+N
// module chunks = 0